import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';

export const Wrapper = styled.div`
	color: ${palette('white')};
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	padding: 32px 16px 16px;
	position: relative;
	width: 100%;

	${minWidth('tablet')} {
		padding: 64px 24px 32px;
	}

	${minWidth('desktop')} {
		padding: 140px 0 32px;
	}
`;

export const Background = styled(FullscreenBackground)`
	${minWidth('desktop')} {
		display: none;
	}

	&:after {
		background: rgba(0, 0, 0, 0.4);
		bottom: 0;
		content: '';
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
	}
`;

export const Content = styled.div`
	max-width: 480px;
	margin: 0 auto;

	${minWidth('desktop')} {
		max-width: 960px;
	}

	${minWidth('desktopLarge')} {
		max-width: 1168px;
	}
`;

export const HeadlineContainer = styled.div`
	align-items: center;
	border-bottom: 1px ${palette('white')} solid;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-bottom: 20px;
	padding-bottom: 20px;

	${minWidth('desktop')} {
		flex-direction: row;
		justify-content: flex-start;
		margin-bottom: 32px;
		padding-bottom: 32px;
	}
`;

export const Logo = styled.img`
	flex: 0 0 60px;
	height: 60px;
	width: 60px;
	margin-bottom: 16px;

	${minWidth('tablet')} {
		flex: 0 0 80px;
		height: 80px;
		margin-bottom: 20px;
		width: 80px;
	}

	${minWidth('desktop')} {
		flex: 0 0 100px;
		height: 100px;
		width: 100px;
		margin-bottom: 0;
		margin-right: 32px;
	}
`;

export const Headline = styled.h3`
	${fontWeight(FontWeights.Regular)};
`;

export const SubHeadline = styled.p`
	${fontWeight(FontWeights.Medium)};
	text-align: center;

	${minWidth('desktop')} {
		text-align: left;
	}
`;
